/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import React from 'react';
import 'prop-types';

const arrowDirection = direction => direction === 'DOWN' ? 'rotate(180 5.5 7.5)' : null;

const TideArrow = ({
  direction
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 11 15",
  preserveAspectRatio: "xMinYMin meet",
  className: "quiver-tide-arrow"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "5.5,0 11,5.5 8,5.5 8,15 3,15 3,5.5 0,5.5",
  transform: arrowDirection(direction)
}));

TideArrow.defaultProps = {
  direction: 'UP'
};

export default TideArrow;
//# sourceMappingURL=TideArrow.js.map
